import { SCREEN_NAME, IMPRESSION_ACTIONS, CLICK_ACTIONS } from "@payment-client/analytics/constants";
import { AnalyticsContextValue } from "@swiggy-private/analytics";

const LABELS = {
    COUPON_TRUE: "coupon-true",
    COUPON_FALSE: "coupon-false",
    CHECKED: "checked",
    UNCHECKED: "unchecked",
    LAST_USED: "last used",
    RECOMMENDED: "recommended",
};

export const impressionPaymentFailureHalfCard = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    failureReason: string,
): void => {
    impressionEvent({
        category: SCREEN_NAME.PAYMENT_HALF_CARD,
        action: IMPRESSION_ACTIONS.IMPRESSION_PAYMENT_FAILURE_HALF_CARD,
        label: failureReason || "-",
    });
};

export const impressionRecommendedPaymentMethod = (
    groupName: string,
    isCouponApplicable: boolean,
    impressionEvent: AnalyticsContextValue["impressionEvent"],
): void => {
    impressionEvent({
        category: SCREEN_NAME.PAYMENT_HALF_CARD,
        action: IMPRESSION_ACTIONS.IMPRESSION_RECOMMENDED_PAYMENT_METHOD,
        label: groupName,
        context: isCouponApplicable ? LABELS.COUPON_TRUE : LABELS.COUPON_FALSE,
    });
};

export const impressionLastUsedPaymentMethod = (
    groupName: string,
    isCouponApplicable: boolean,
    impressionEvent: AnalyticsContextValue["impressionEvent"],
): void => {
    impressionEvent({
        category: SCREEN_NAME.PAYMENT_HALF_CARD,
        action: IMPRESSION_ACTIONS.IMPRESSION_LAST_USED_PAYMENT_METHOD,
        label: groupName,
        context: isCouponApplicable ? LABELS.COUPON_TRUE : LABELS.COUPON_FALSE,
    });
};

export const impressionMorePaymentMethodsHalfCard = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
): void => {
    impressionEvent({
        category: SCREEN_NAME.PAYMENT_HALF_CARD,
        action: IMPRESSION_ACTIONS.IMPRESSION_MORE_PAYMENT_METHODS_HALF_CARD,
    });
};

export const impressionTechnicalFailureHalfCard = (impressionEvent: AnalyticsContextValue["impressionEvent"]): void => {
    impressionEvent({
        category: SCREEN_NAME.PAYMENT_HALF_CARD,
        action: IMPRESSION_ACTIONS.IMPRESSION_TECHNICAL_FAILURE_HALF_CARD,
    });
};

export const clickRecommendedPaymentMethod = (
    groupName: string,
    isCouponApplicable: boolean,
    clickEvent: AnalyticsContextValue["clickEvent"],
): void => {
    clickEvent({
        category: SCREEN_NAME.PAYMENT_HALF_CARD,
        action: CLICK_ACTIONS.CLICK_RECOMMENDED_PAYMENT_METHOD,
        label: groupName,
        context: isCouponApplicable ? LABELS.COUPON_TRUE : LABELS.COUPON_FALSE,
    });
};

export const clickLastUsedPaymentMethod = (
    groupName: string,
    isCouponApplicable: boolean,
    clickEvent: AnalyticsContextValue["clickEvent"],
): void => {
    clickEvent({
        category: SCREEN_NAME.PAYMENT_HALF_CARD,
        action: CLICK_ACTIONS.CLICK_LAST_USED_PAYMENT_METHOD,
        label: groupName,
        context: isCouponApplicable ? LABELS.COUPON_TRUE : LABELS.COUPON_FALSE,
    });
};
export const clickMorePaymentMethodsHalfCard = (clickEvent: AnalyticsContextValue["clickEvent"]): void => {
    clickEvent({
        category: SCREEN_NAME.PAYMENT_HALF_CARD,
        action: CLICK_ACTIONS.CLICK_MORE_PAYMENT_METHODS_HALF_CARD,
    });
};
export const clickProceedToPayHalfCard = (
    groupName: string,
    isLastUsedPm: boolean,
    clickEvent: AnalyticsContextValue["clickEvent"],
): void => {
    clickEvent({
        category: SCREEN_NAME.PAYMENT_HALF_CARD,
        action: CLICK_ACTIONS.CLICK_PROCEED_TO_PAY_HALF_CARD,
        label: groupName,
        context: isLastUsedPm ? LABELS.LAST_USED : LABELS.RECOMMENDED,
    });
};
export const clickToggleSwiggyPay = (
    splitPayChecked: boolean,
    clickEvent: AnalyticsContextValue["clickEvent"],
): void => {
    clickEvent({
        category: SCREEN_NAME.PAYMENT_HALF_CARD,
        action: CLICK_ACTIONS.CLICK_TOGGLE_SWIGGY_PAY,
        context: splitPayChecked ? LABELS.CHECKED : LABELS.UNCHECKED,
    });
};
export const clickTryOtherPayment = (clickEvent: AnalyticsContextValue["clickEvent"]): void => {
    clickEvent({
        category: SCREEN_NAME.PAYMENT_HALF_CARD,
        action: CLICK_ACTIONS.CLICK_TRY_OTHER_PAYMENT,
    });
};
